import React from 'react';
import { TemplateDefault } from 'src/templates/TemplateDefault';

// import s from './Contact.module.scss';

export const Contact: React.FC = () => {
  return <TemplateDefault>Contact</TemplateDefault>;
};
